<template>
  <div>
    <v-dialog v-model="show_dialog_box" max-width="1000px">
      <template v-slot:activator="{ on }">
        <v-btn small class="mx-2 my-1 light--text text-capitalize" v-on="on" tile color="primary" @click="showDialog()">Copy</v-btn>
      </template>
      <v-card class="ma-0 pa-4" color="pop_bg">
        <v-card-text>
          <v-row>
            <span class="mt-3 dark--text text-h6 ms-2"> Duplicate Package</span>
            <v-spacer></v-spacer>
            <v-btn color="dark" text @click="close"><v-icon>mdi-close</v-icon></v-btn>
          </v-row>
          <v-divider class="mt-5"></v-divider>
          <v-form class="pa-sm-8" v-model="valid" ref="form">
            <v-layout wrap class="mb-5">
              <h4 class="font-weight-bold text-body-1 dark--text">
                Change Name
              </h4>
              <v-spacer></v-spacer>
            </v-layout>
            <v-layout wrap class="mt-6 mt-sm-0">
              <v-flex xs12 sm3 md2>
                <h4 class="text-body-2 dark--text">Plan Name</h4>
              </v-flex>
              <v-flex xs12 sm8 md4>
                <v-text-field v-model="titleEn" placeholder="Plan Name" :rules="[requiredValidator('plan name')]" solo dense></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs12 sm3 md2>
                <h4 class="text-body-2 dark--text">Plan Name Arabic</h4>
              </v-flex>
              <v-flex xs12 sm8 md4>
                <v-text-field v-model="titleAr" placeholder="Plan Name Arabic" :rules="[requiredValidator('plan name in arabic')]" solo dense></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout justify-end class="mt-8">
              <v-btn color="primary" class="light--text text-capitalize" :width="$vuetify.breakpoint.xs ? 200 : 300" @click="duplicatePackage()" :loading="btnloading" :disabled="!valid"
                >Duplicate Package</v-btn
              >
            </v-layout>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snack" timeout="3000" right top color="success">{{ snackText }}</v-snackbar>
  </div>
</template>

<script>
import { requiredValidator } from "../../core/methods/validations";
export default {
  props: {
    package_id: {
      type: String,
    },
  },
  components: {},

  data() {
    return {
      snack: false,
      snackText: "",
      requiredValidator: requiredValidator,
      show_dialog_box: false,
      btnloading: false,
      valid: true,
      // form data
      titleEn: null,
      titleAr: null,
      package: null,
    };
  },
  methods: {
    showDialog() {
      this.getPackageById();
    },
    getPackageById() {
      this.$apollo
        .query({
          query: require("../api/getPackageById.graphql"),
          variables: {
            packageId: this.package_id,
          },
          fetchPolicy: "network-only",
        })
        .then(data => {
          this.package = data.data.getPackageById;
        });
    },

    showSnack(text) {
      this.snack = true;
      this.snackText = text;
    },
    close() {
      this.show_dialog_box = false;
    },
    //api methods
    duplicatePackage() {
      if (!this.package) {
        this.showSnack("Package data not loaded yet. Please try again.");
        return;
      }
      this.btnloading = true;
      this.$apollo
        .mutate({
          mutation: require("@/menu-packages/api/duplicatePackages.graphql"),
          variables: {
            id: this.package._id,
            titleEn: this.titleEn,
            titleAr: this.titleAr,
          },
        })
        .then(() => {
          this.btnloading = false;
          this.$root.$emit("updatePackage");
          this.close();
        })
        .catch(error => {
          if (error.graphQLErrors != null) {
            console.error(error.graphQLErrors);
          }
          this.btnloading = false;
          this.showSnack("something went wrong", true, error);
        });
    },
  },
};
</script>